(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kesa-sale-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kesa-sale-ticker')) {
    customElements.define('kesa-sale-ticker', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.button = this.querySelector('.kesa-sale-ticker__toggle');
        this.group = this.querySelector('.kesa-sale-ticker__group');
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.setPaused(this.motionPreference.matches);
        this.button.hidden = false;
        this.button.addEventListener('click', () => {
          const paused = this.dataset.paused === 'true';
          this.dataset.motionEnabled = String(paused);
          this.setPaused(!paused);
        }, { signal: this.controller.signal });
        this.motionPreference.addEventListener('change', (event) => {
          this.dataset.motionEnabled = 'false';
          this.setPaused(event.matches);
        }, { signal: this.controller.signal });
        this.observer = new ResizeObserver(() => {
          document.documentElement.style.setProperty('--kesa-sale-ticker-height', `${this.offsetHeight}px`);
          this.style.setProperty('--kesa-ticker-duration', `${Math.max(this.group.offsetWidth / 60, 16)}s`);
        });
        this.observer.observe(this);
        this.observer.observe(this.group);
      }

      setPaused(paused) {
        this.dataset.paused = String(paused);
        this.button.setAttribute('aria-pressed', String(paused));
        this.button.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.button.title = this.button.getAttribute('aria-label');
        this.button.querySelector('.kesa-sale-ticker__button-text').textContent = paused
          ? this.dataset.playLabel.split(' ')[0]
          : this.dataset.pauseLabel.split(' ')[0];
      }

      disconnectedCallback() {
        this.controller.abort();
        this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
